import { isLoadingSelector, isUpdatedSelector, errorSelector } from '../utils/helperSelectors';
const reducerName = 'accountEmailUpdate';
export const isAccountEmailUpdateLoadingSelector = isLoadingSelector(reducerName);
export const isAccountEmailUpdateUpdatedSelector = isUpdatedSelector(reducerName);
export const accountEmailUpdateErrorSelector = errorSelector(reducerName);
//# sourceMappingURL=selectors.js.map